//
// Imports
//

import * as FritterApiUtilities from "@donutteam/fritter-api-utilities";
import { z } from "zod";

//
// Types
//

export type RequestBody = z.infer<typeof RequestBodySchema>;

export const RequestBodySchema = z.object(
	{
		currentPassword: z.string(),
		
		requestDeletion: z.boolean(),

		requestDeletionFeedback: z
			.string()
			.trim()
			.max(4096)
			.nullish()
			.transform((value) => value == "" ? null : value),
	});

export type ResponseBody = z.infer<typeof ResponseBodySchema>;

export const ResponseBodySchema = z.union(
	[
		FritterApiUtilities.SuccessResponseBodySchema,

		FritterApiUtilities.ErrorResponseBodySchema,
	]);